/*
 * Methods for conversion of common nullable values to formik values.
 *
 * Also contains types for formik values that should be used within formik forms.
 */

export type FormikNumber = number | ''
export type FormikString = string | ''

/**
 * Gets 's' if 's' is non-empty string, null otherwise.
 * @param s string
 * @returns string or null if empty
 */
export function getStringOrNullIfEmpty(s: FormikString): string | null {
  if (s === '') {
    return null
  }
  return s
}

/**
 * Gets 's' if 's' is not null, empty string otherwise.
 * @param s string or null
 * @returns string or empty string
 */
export function getStringOrEmptyIfNull(s: string | null): FormikString {
  return s ?? ''
}

/**
 * Gets 'n' if 'n' is a number, null otherwise.
 * @param n number
 * @returns number or null if empty
 */
export function getNumberOrNullIfEmpty(n: FormikNumber): number | null {
  if (n === '') {
    return null
  }
  return n
}

/**
 * Gets 'n' if 'n' is not null, empty string otherwise.
 * @param n number or null
 * @returns number or empty number
 */
export function getNumberOrEmptyIfNull(n: number | null): FormikNumber {
  return n ?? ''
}
